import React, { useEffect, useState } from "react";
import { Box, Button, Drawer, Typography, IconButton } from "@mui/material";
import InputField from "../../../Components/Masters/InputField";
import CloseIcon from "@mui/icons-material/Close";
import MonthYearPicker from "./MonthYearPicker";
import DynamicTable from "./DynamicTable";
import CollapsibleSection from "./CollapsibleSection";
import {
  validateNumber,
  validateNumberInput,
} from "../../../utils/validateFields";
import { api, post, put } from "../../../utils/api";
import EditDialog from "../../../Components/Common/EditDialog";

const AddData = ({
  inputData,
  addData,
  handleClose,
  setsnackOpen,
  updateUrl,
  addUrl,
  id,
  fetchData,
  element,
  data,
}) => {
  const [expanded, setExpanded] = useState({ waterWithdrawal: true });
  const [openDialog, setOpenDialog] = React.useState(false);
  const [fieldToRemove, setFieldToRemove] = React.useState({
    fieldName: "",
    rowIndex: null,
  });
  const handleExpand = (section) => {
    setExpanded((prev) => ({ ...prev, [section]: !prev[section] }));
  };
  const [selectedMonth, setSelectedMonth] = useState(""); // Stores the selected month
  const [selectedYear, setSelectedYear] = useState(""); // Stores the selected year
  const [errors, setErrors] = useState({});

  const emptyInitialState = {
    monthYear: {
      year: 2024, // Default year
      month: "09", // Default month
    },
    waterWithdrawal: [
      {
        serialNo: 1,
        source: "",
        quantity: "",
        remarks: "",
        documents: [],
      },
    ],
    waterDischarge: [
      {
        serialNo: 1,
        source: "",
        quantity: "",
        remarks: "",
        documents: [],
      },
    ],
    wastewaterTreatment: [
      {
        serialNo: 1,
        source: "",
        treatmentLevel: "",
        quantity: "",
        documents: [],
      },
    ],
    waterRecycling: [
      {
        serialNo: 1,
        parameter: "",
        treatmentLevel: "",
        quantity: "",
        documents: [],
      },
    ],
    interactionWithWater: {
      engagementWithWaterResources: "",
      waterWithdrawalLocations: [
        {
          serialNo: 1,
          source: "",
          location: "",
          quantity: "",
          documents: [],
        },
      ],
      waterRelatedImpacts: "",
      waterRiskManagement: "",
    },
  };

  const elementInitialState = {
    monthYear: {
      year: element?.monthYear?.year || "",
      month: element?.monthYear?.month || "",
    },
    waterWithdrawal: Array.isArray(element?.waterWithdrawal)
      ? element.waterWithdrawal.map((item) => ({
          serialNo: item?.serialNo || "",
          source: item?.source || "",
          quantity: item?.quantity || "",
          remarks: item?.remarks || "",
          documents: item?.documents || [],
        }))
      : emptyInitialState.waterWithdrawal,

    waterDischarge: Array.isArray(element?.waterDischarge)
      ? element.waterDischarge.map((item) => ({
          serialNo: item?.serialNo || "",
          source: item?.source || "",
          quantity: item?.quantity || "",
          remarks: item?.remarks || "",
          documents: item?.documents || [],
        }))
      : emptyInitialState.waterDischarge,

    wastewaterTreatment: Array.isArray(element?.wastewaterTreatment)
      ? element.wastewaterTreatment.map((item) => ({
          serialNo: item?.serialNo || "",
          source: item?.source || "",
          treatmentLevel: item?.treatmentLevel || "",
          quantity: item?.quantity || "",
          documents: item?.documents || [],
        }))
      : emptyInitialState.wastewaterTreatment,

    waterRecycling: Array.isArray(element?.waterRecycling)
      ? element.waterRecycling.map((item) => ({
          serialNo: item?.serialNo || "",
          parameter: item?.parameter || "",
          treatmentLevel: item?.treatmentLevel || "",
          quantity: item?.quantity || "",
          documents: item?.documents || [],
        }))
      : emptyInitialState.waterRecycling,

    interactionWithWater: {
      engagementWithWaterResources:
        element?.interactionWithWater?.engagementWithWaterResources || "",
      waterWithdrawalLocations: Array.isArray(
        element?.interactionWithWater?.waterWithdrawalLocations
      )
        ? element.interactionWithWater.waterWithdrawalLocations.map((item) => ({
            serialNo: item?.serialNo || "",
            source: item?.source || "",
            location: item?.location || "",
            quantity: item?.quantity || "",
            documents: item?.documents || [],
          }))
        : emptyInitialState.interactionWithWater.waterWithdrawalLocations,
      waterRelatedImpacts:
        element?.interactionWithWater?.waterRelatedImpacts || "",
      waterRiskManagement:
        element?.interactionWithWater?.waterRiskManagement || "",
    },
  };

  useEffect(() => {
    setErrors({});
    const initialState = element ? elementInitialState : emptyInitialState;
    setFormData(initialState);
    setFormData1(initialState);
    setRows({
      waterWithdrawal: initialState.waterWithdrawal,
      waterDischarge: initialState.waterDischarge,
      wastewaterTreatment: initialState.wastewaterTreatment,
      waterRecycling: initialState.waterRecycling,
      interactionWithWater:
        initialState.interactionWithWater.waterWithdrawalLocations,
    });
  }, [element, id]);

  const [formData, setFormData] = useState(emptyInitialState);
  const [formData1, setFormData1] = useState(emptyInitialState);
  const [editDialog, setEditDialog] = useState(false);

  const rowsInitialState = {
    waterWithdrawal: elementInitialState.waterWithdrawal || "",
    waterDischarge: elementInitialState.waterDischarge || "",
    wastewaterTreatment: elementInitialState.wastewaterTreatment || "",
    waterRecycling: elementInitialState.waterRecycling || "",
    interactionWithWater:
      elementInitialState.interactionWithWater.waterWithdrawalLocations || "",
  };
  const [rows, setRows] = useState({});

  useEffect(() => {
    setErrors({});
    setFormData(elementInitialState);
    setFormData1(elementInitialState);
    setRows(rowsInitialState);
  }, [element]);

  const handleAddRow = (fieldName) => {
    setRows((prev) => {
      const updatedRows = [...(prev[fieldName] || [])]; // Ensure you have an array of rows
      if (fieldName === "interactionWithWater")
        updatedRows.push({
          ...emptyInitialState[fieldName]["waterWithdrawalLocations"][0],
          serialNo: updatedRows.length + 1,
        });
      // Add the new row to the array
      else
        updatedRows.push({
          ...emptyInitialState[fieldName][0],
          serialNo: updatedRows.length + 1,
        }); // Add the new row to the array
      return {
        ...prev,
        [fieldName]: updatedRows, // Update the specific field with the new rows array
      };
    });
  };

  const handleRemoveRow = (fieldName, rowIndex) => {
    setRows((prev) => {
      const fieldRows = prev[fieldName] || [];
      const isEmptyRow = Object.entries(fieldRows[rowIndex] || {}).every(
        ([key, value]) =>
          key === "serialNo" ||
          value === undefined ||
          value === null ||
          value === "" ||
          value === "Tap to Select" ||
          value.length === 0
      );

      if (isEmptyRow) {
        const newRows = [...fieldRows];
        newRows.splice(rowIndex, 1); // Remove the row
        setErrors((prevErrors) => {
          const newErrors = { ...prevErrors };
          if (newErrors[fieldName] && newErrors[fieldName][rowIndex]) {
            // Remove the error for this specific row and field
            delete newErrors[fieldName][rowIndex];
          }
          return newErrors;
        });
        return {
          ...prev,
          [fieldName]: newRows,
        };
      } else {
        // If row is not empty, show a dialog to confirm deletion
        setOpenDialog(true); // Show the dialog
        setFieldToRemove({ fieldName, rowIndex }); // Store the row to be removed
        return prev; // No state change to `rows` here
      }
    });
  };

  // Function to confirm the deletion
  const confirmRemoveRow = () => {
    const { fieldName, rowIndex } = fieldToRemove;
    setRows((prev) => {
      const fieldRows = prev[fieldName] || [];
      const newRows = [...fieldRows];
      newRows.splice(rowIndex, 1); // Remove the row
      setFormData((prevFormData) => {
        const updatedFormData = {
          ...prevFormData,
          [fieldName]:
            fieldName === "interactionWithWater"
              ? {
                  ...prevFormData.interactionWithWater,
                  waterWithdrawalLocations: newRows,
                }
              : newRows,
        };
        return updatedFormData;
      });
      return {
        ...prev,
        [fieldName]: newRows,
      };
    });

    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      if (newErrors[fieldName] && newErrors[fieldName][rowIndex]) {
        // Remove the error for this specific row and field
        delete newErrors[fieldName][rowIndex];
      }
      return newErrors;
    });

    setOpenDialog(false); // Close the dialog after confirmation
  };

  // Function to cancel the deletion
  const cancelRemoveRow = () => {
    setOpenDialog(false); // Simply close the dialog without deleting
  };

  const handleRowChange = async (fieldName, index, field, value) => {
    if (field === "quantity" && !validateNumberInput(value) && value !== "")
      return;

    setRows((prev) => {
      const updatedRows = [...(prev?.[fieldName] || [])];
      updatedRows[index] = updatedRows[index]
        ? { ...updatedRows[index], [field]: value }
        : { [field]: value };

      setFormData((prevFormData) => {
        const updatedFormData = {
          ...prevFormData,
          [fieldName]:
            fieldName === "interactionWithWater"
              ? {
                  ...prevFormData.interactionWithWater,
                  waterWithdrawalLocations: updatedRows,
                }
              : updatedRows,
        };
        return updatedFormData;
      });

      return { ...prev, [fieldName]: updatedRows };
    });

    // Clear error for the specific field if valid value is entered
    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };

      if (
        newErrors[fieldName] &&
        newErrors[fieldName][index] &&
        newErrors[fieldName][index][field]
      ) {
        if (
          newErrors[fieldName] &&
          newErrors[fieldName][index] &&
          newErrors[fieldName][index][field]
        ) {
          delete newErrors[fieldName][index][field];

          // Clean up empty error objects
          if (Object.keys(newErrors[fieldName][index]).length === 0) {
            delete newErrors[fieldName][index];
          }
          if (Object.keys(newErrors[fieldName] || {}).length === 0) {
            delete newErrors[fieldName];
          }
        }
      }

      return newErrors;
    });
  };

   const validateForm = () => {
    const newErrors = {}; // Object to collect error messages

    let isValid = true;

    if (!validateNumber(selectedMonth) || selectedMonth === "") {
      newErrors["month"] = "required";
      isValid = false;
    }
    if (!validateNumber(selectedYear) || selectedYear === "") {
      newErrors["year"] = "required";
      isValid = false;
    }

    let existMonthYear = data?.find(
      (el) =>
        el?.monthYear?.month === selectedMonth &&
        el?.monthYear?.year === selectedYear
    );
    if (existMonthYear && existMonthYear?.id !== element?.id) {
      newErrors["consumptionMonth"] =
        "This Month & Year Entry is already Exists.";
      isValid = false;
    }

    // Iterate over each table defined in inputData
    inputData.forEach((input) => {
      // If the table has rows (array), validate each row
      if (input.type === "array") {
        const fields =
          input.fieldName === "interactionWithWater"
            ? input.waterWithdrawalLocations?.fields
            : input.fields;

        const rowList =
          input.fieldName === "interactionWithWater"
            ? rows.interactionWithWater
            : rows[input.fieldName]; // Get the rows for the table

        // Iterate over each field and each row in the table
        fields?.forEach((field) => {
          const fieldName = field.fieldName;

          // if (input.fieldName === "interactionWithWater") {
          //   // Validate specific subfields in "interactionWithWater"
          //   if (
          //     formData.interactionWithWater.engagementWithWaterResources === ""
          //   ) {
          //     newErrors["engagementWithWaterResources"] = "required";
          //     isValid=false;
          //   }

          //   if (formData.interactionWithWater.waterRelatedImpacts === "") {
          //     newErrors["waterRelatedImpacts"] = "required";
          //     isValid=false;
          //   }

          //   if (formData.interactionWithWater.waterRiskManagement === "") {
          //     newErrors["waterRiskManagement"] = "required";
          //     isValid=false;
          //   }
          // }

          // Iterate over each row and validate the field
          rowList?.forEach((row, rowIndex) => {
            const value = row[fieldName];

            const isEmptyRow = Object.entries(rowList[rowIndex] || {}).every(
              ([key, value]) =>
                key === "serialNo" ||
                value === undefined ||
                value === null ||
                value === "" ||
                value === "Tap to select" ||
                value?.length === 0
            );
            // if ((input.fieldName === "waterWithdrawal" && rowIndex === 0 )|| (rowIndex>0)) {
            if (
              isEmptyRow &&
              ((input.fieldName === "waterWithdrawal" && rowIndex === 0) ||
                rowIndex > 0)
            ) {
              // Mark all fields in the first row as required
              if (!newErrors[input.fieldName]) {
                newErrors[input.fieldName] = [];
              }
              if (!newErrors[input.fieldName][rowIndex]) {
                newErrors[input.fieldName][rowIndex] = {};
              }
              fields.forEach((field) => {
                if (
                  field.fieldName !== "remarks" &&
                  field.fieldName !== "documents" &&
                  field.fieldName !== "serialNo"
                ) {
                  newErrors[input.fieldName][rowIndex][field.fieldName] =
                    "required";
                  isValid = false;
                }
              });
            } else if (isEmptyRow) return;

            if (!newErrors[input.fieldName]) {
              newErrors[input.fieldName] = [];
            }
            if (!newErrors[input.fieldName][rowIndex]) {
              newErrors[input.fieldName][rowIndex] = {};
            }
            if (fieldName === "remarks") return;
            // Validation: Check if the field is required and empty
            if (typeof value === "string" && (!value || value === "")) {
              // If field is required but empty, set an error
              newErrors[input.fieldName][rowIndex][fieldName] = "required";
              isValid = false;
            }
          });
        });
      }
    });
    setErrors(newErrors);
    return isValid; // No errors, form is valid
  };


  const handleFileUpload = async (fieldName, index, field, files) => {
    // if (files.length === 0) return;


    const allowedTypes = [
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ];

    for (let file of files) {
      if (!allowedTypes.includes(file.type)) {
        alert("Only .pdf, .doc, .docx, .xls, .xlsx files are allowed!");
        // e.target.value = null; // Clear the input
        return;
      }
    }

    const formData = new FormData();
    for (let file of files) {
      formData.append("files", file);
    }

    // setIsLoading(true);
    // setErrorMessage("");

    try {
      const response = ""

      const fileUrls = response?.data?.urls || [];
      // setUploadedFiles(fileUrls); // Store the URLs


      let updatedRows;
      setRows((prev) => {
        updatedRows = [
          ...prev[
            fieldName === "interactinWithWater"
              ? fieldName?.waterWithDrawalLocations
              : fieldName
          ],
        ];
        updatedRows[index] = updatedRows[index]
          ? { ...updatedRows[index], [field]: fileUrls?.name }
          : { [field]: fileUrls };
        return { ...prev, [fieldName]: updatedRows };
      });

      setFormData((prevFormData) => {
        const updatedFormData = {
          ...prevFormData,
          [fieldName]: updatedRows,
        };
        return updatedFormData;
      });
    } catch (error) {
      console.error("Error uploading files:", error);
      // setErrorMessage("Failed to upload the files. Please try again.");
    } finally {
      // setIsLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setErrors({ ...errors, [name]: "" });
    setFormData({
      ...formData,
      interactionWithWater: {
        ...formData.interactionWithWater,
        [name]: value,
      },
    });
  };

  const handleExitAgree = () => {
    setEditDialog(false);
    handleClose();
    setRows(rowsInitialState);
    setFormData(element ? elementInitialState : emptyInitialState);
    setFormData1(element ? elementInitialState : emptyInitialState);
    setExpanded({ waterWithdrawal: true });
    setErrors({});
    handleClose();
  };

  const handleExit = () => {
    const isFormDataUnchanged = Object.keys(formData).every(
      (key) => formData[key] === formData1[key]
    );

  

    if (
      isFormDataUnchanged &&
      formData?.monthYear?.month === selectedMonth &&
      formData?.monthYear?.year === selectedYear
    ) {
      handleExitAgree();
    } else {
      setEditDialog(true); // Show the EditDialog if there are changes
    }
  };

  const Save = async () => {
    if (!validateForm()) return;
    const dataToSend = {
      ...formData,
      monthYear: { month: selectedMonth, year: selectedYear },
    };
    let method = id ? put : post;
    let url = id ? `${updateUrl}?Id=${id}` : addUrl;
    await method(url, dataToSend)
      .then((res) => {
        setsnackOpen({
          open: true,
          message: res.data.message,
          severity: "success",
        });
        fetchData();
        setFormData(emptyInitialState);
        setRows(rowsInitialState);
        handleClose();
      })
      .catch((err) => {
        console.log(err.response.data);
        if (err.response && err.response.data && err.response.data.errors) {
          const errorMessages = err.response.data.errors
            .map((error) => error.msg)
            .join(", ");
          setsnackOpen({
            open: true,
            message: errorMessages,
            severity: "error",
          });
        }
      });
  };

  const list = () => (
    <Box
      display="flex"
      gap={3}
      sx={{
        maxWidth: "100%",
        minHeight: "100vh",
        overflowY: "auto",
        overflowX: "hidden",
      }}
    >
      {editDialog && (
        <EditDialog {...{ editDialog, setEditDialog, handleExitAgree }} />
      )}
      <Box
        sx={{
          backgroundColor: "#fff",
          height: "25px",
          margin: "30px 0 0 0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "80%",
          width: "1.6rem",
        }}
      >
        <IconButton onClick={handleExit} sx={{ color: "black" }}>
          <CloseIcon sx={{ fontSize: "1.2rem" }} />
        </IconButton>
      </Box>
      <Box
        sx={{
          width: "720px",
          maxWidth: "100%",
          p: 4,
          backgroundColor: "#fff",
          height: "auto",
          minHeight: "100%",
          overflowY: "auto",
        }}
      >
        {" "}
        <Typography
          variant="h6"
          sx={{ textDecoration: "underline", fontWeight: "bold", mb: 2 }}
        >
          {element && id ? "Edit" : "Add"} Water Data Collection
        </Typography>
        <Box sx={{ gap: 2 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
            1. Consumption Month
          </Typography>
          <Box sx={{ mb: 2, width: "50%" }}>
            <MonthYearPicker
              {...{
                setSelectedMonth,
                setSelectedYear,
                selectedMonth,
                selectedYear,
                errors,
                setErrors,
                defaultMonth: element?.monthYear?.month || "",
                defaultYear: element?.monthYear?.year || "",
              }}
            />
            <Typography variant="body2" color="#D34040">
              {errors["consumptionMonth"]}
            </Typography>
          </Box>
        </Box>
        {inputData?.map((section, idx) => (
          <Box sx={{ borderBottom: "1px solid #DBDBDB" }}>
            <CollapsibleSection
              key={section?.fieldName}
              title={section.title}
              idx={idx + 1}
              expanded={expanded[section?.fieldName]}
              onToggle={() => handleExpand(section?.fieldName)}
            >
              {section.fieldName === "interactionWithWater" && (
                <Box sx={{ mb: 1 }}>
                  <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
                    A. Engagement with Water Resources:<br></br>
                    How does the organization engage with water resources in
                    community?
                  </Typography>
                  <InputField
                    errors={errors["engagementWithWaterResources"]}
                    handleChange={handleChange}
                    fieldName={"engagementWithWaterResources"}
                    placeholder="Enter Text"
                    value={
                      formData.interactionWithWater
                        ?.engagementWithWaterResources
                    }
                  />
                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: "bold", mt: 1 }}
                  >
                    B. Water Withdrawl Locations:<br></br>
                    Where does the organization withdraw water from
                    (e.g.,rivers, lakes, aquifers)? Provide specific locations &
                    quantities.
                  </Typography>
                  {/* <InputField title="Where does the organization withdraw water from (e.g.,rivers, lakes, aquifers)? Provide specific locations & quantities." /> */}
                </Box>
              )}
              <DynamicTable
                fieldName={section?.fieldName}
                fields={
                  section?.fieldName === "interactionWithWater"
                    ? section?.waterWithdrawalLocations?.fields
                    : section?.fields
                }
                handleClose={handleClose}
                rows={rows[section.fieldName] || []}
                onRowChange={handleRowChange}
                handleFileUpload={handleFileUpload}
                errors={errors[section.fieldName]}
                onAddRow={() => handleAddRow(section.fieldName)}
                onRemoveRow={handleRemoveRow}
                {...{ confirmRemoveRow, cancelRemoveRow, openDialog, formData }}
              />
              {section.fieldName === "interactionWithWater" && (
                <Box>
                  <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
                    C. Water-Related Impacts:<br></br>
                    Describe any significant water-related impacts your
                    organization has observed or is addressing.
                  </Typography>
                  <InputField
                    errors={errors["waterRelatedImpacts"]}
                    handleChange={handleChange}
                    placeholder="Enter Text"
                    fieldName={"waterRelatedImpacts"}
                    value={formData.interactionWithWater?.waterRelatedImpacts}
                  />
                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: "bold", mt: 1 }}
                  >
                    D. Water Risk Management:<br></br>
                    What measures are in place to manage water-related risks?
                  </Typography>
                  <InputField
                    errors={errors["waterRiskManagement"]}
                    handleChange={handleChange}
                    fieldName={"waterRiskManagement"}
                    placeholder="Enter Text"
                    value={formData.interactionWithWater?.waterRiskManagement}
                  />
                </Box>
              )}
            </CollapsibleSection>
          </Box>
        ))}
        {/* <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}> */}
        <Button
          variant="contained"
          onClick={Save}
          sx={{
            mt: 3,
            width: "20%",
            textTransform: "none",
            backgroundColor: "#488257",
          }}
        >
          Submit
        </Button>
        {/* </Box> */}
      </Box>
    </Box>
  );

  return (
    <Drawer
      sx={{
        backgroundColor: "transparent",
        height: "100vh",
        minHeight: "100vh",
        overflowY: "auto",
        "& .MuiDrawer-paper": {
          backgroundColor: "transparent",
          boxShadow: "none",
          height: "100%",
          minHeight: "100%",
          overflowY: "auto",
          overflowX: "hidden",
          display: "flex",
          flexDirection: "column",
        },
      }}
      anchor="right"
      open={addData}
      onClose={handleExit}
    >
      {list()}
    </Drawer>
  );
};

export default AddData;
